/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".search[_ngcontent-%COMP%]{height:100%;display:grid;grid-template-rows:80px 1fr}.search__header[_ngcontent-%COMP%]{display:flex;align-items:center}.search__results[_ngcontent-%COMP%]{overflow-y:auto}.search__label[_ngcontent-%COMP%]{font-weight:500}.search__term[_ngcontent-%COMP%]{color:#de3838}.search__navigate[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
